import React from 'react';
import battery from '../assets/img/battery.png';

interface BatteryProps {
  level: number;
}

const Battery: React.FC<BatteryProps> = ({ level }) => (
  <div
    className="battery-wrapper"
    style={{ '--level': `${level}%` } as React.CSSProperties}
  >
    <img
      src={battery}
      className="battery gray"
      alt={`Empty portion of battery (${100 - level}%)`}
    />
    <img src={battery} className="battery color" alt={`Battery at ${level}%`} />
  </div>
);

export default Battery;
